import React, { useContext, useEffect, useState } from "react";
import { BackendContext, backendStatus } from "../../../backend/backend";
import Button from "../../../components/button/button";
import Input from "../../../components/input/input";
import Loading from "../../../components/loading/loading";
import CopyIcon from "../../../components/icons/copy-icon";
import { MainHeaderContext } from "../../../components/main-header/main-header-state";
import { MenuContext } from "../../../components/menu/menu-state";
import Modal, { ModalTypes } from "../../../components/modal/modal";
import { FirebaseContext } from "../../firebase";
import { UserContext } from "../../user-context";
import { LGPDFileLink } from "../lgpd/lgpd-consent";
import { RemotizeType } from "../signup/signup";
import packageJson from "../../../../package.json";
import { useToasts } from "react-toast-notifications";

export default function MyAccountPage() {
  const [isp, setIsp] = useState(null);
  const [deleteConfirm, setDeleteConfirm] = useState(false);
  const [agreementDate, setAgreementDate] = useState(null);
  const [userConsent, setUserConsent] = useState(null);
  const [typeConfirm, setTypeConfirm] = useState(false);
  const [tokenConfirm, setTokenConfirm] = useState(false);
  const [tokenLoading, setTokenLoading] = useState(false);
  const [token, setToken] = useState("");
  const [confirmationText, setConfirmationText] = useState("");
  const { addToast } = useToasts();

  const header = useContext(MainHeaderContext);
  const [user] = useContext(UserContext);
  const menu = useContext(MenuContext);
  const backend = useContext(BackendContext);
  const firebase = useContext(FirebaseContext);

  useEffect(() => {
    header.title.set("Minha conta");

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!user.ispid) return;

    fetchIsp();
    fetchUserConsent();

    // eslint-disable-next-line
  }, [user]);

  useEffect(() => {
    if (userConsent) setAgreementDate(new Date(userConsent.timestamp * 1000));

    // eslint-disable-next-line
  }, [userConsent]);

  const fetchIsp = async () => {
    let result = await backend.retrieveFresh(`isp/${user.ispid}`);

    if (result.status === backendStatus.SUCCESS) {
      setIsp(result.content);
    }
  };

  const fetchUserConsent = async () => {
    let result = await backend.retrieveFresh(`lgpd/consent/${user.username}`);

    if (result.status === backendStatus.SUCCESS) {
      setUserConsent(result.content);
      return;
    }

    setTimeout(fetchUserConsent, 2000);
  };

  const proceedToTypeConfirmation = (confirmed) => {
    setDeleteConfirm(false);
    setTypeConfirm(false);

    if (!confirmed) return;

    setTypeConfirm(true);
  };

  const deleteUser = async (confirmed) => {
    let result = await backend.delete(`users/${user.username}`);
    if (result.status !== backendStatus.SUCCESS)
      console.error("Error deleting user:", result.content);

    firebase.signOut();
  };

  const handleCreateToken = async () => {
    setTokenLoading(true);
    let result = await backend.create("keys/nms");
    if (result.status === backendStatus.SUCCESS) {
      setToken(result.content.key);
    } else {
      addToast("", {
        appearance: "error",
        autoDismiss: true,
        autoDismissTimeout: 1500,
      });
    }
    setTokenLoading(false);
  };

  const copyToken = async () => {
    try {
      await navigator.clipboard.writeText(token);
      addToast("Token copiado!", {
        appearance: "success",
        autoDismiss: true,
        autoDismissTimeout: 1500,
      });
    } catch (err) {
      const textArea = document.createElement("textarea");
      textArea.value = token;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
    }
  };

  const deleteAccountModalContent = () => {
    return (
      <div className="delete-account-modal">
        <br></br>
        Ao deletar a conta, removeremos automaticamente todos os seus dados
        vinculados ao Portal Remotize.
        <br></br>
        <br></br>
        {user.last_admin ? (
          <div>
            Além disso, você é o único administrador cadastrado para o provedor{" "}
            <b>{isp?.name}</b>. Assim, as seguintes ações também serão
            realizadas:
            <ul>
              <li>Todos os dados do provedor serão removidos.</li>
              <li>
                Todas as contas de usuário vinculadas provedor serão removidas.
              </li>
              <li>
                Todos os roteadores vinculados ao provedor serão desassociados
              </li>
              <li>
                Todos os roteadores desassociados (ação acima) voltarão ao
                padrão de fábrica <b>Intelbras</b>
              </li>
            </ul>
            <div className="centered">
              <b>Deseja deletar sua conta?</b>
            </div>
          </div>
        ) : null}
      </div>
    );
  };

  const typeConfirmModalContent = () => {
    return (
      <div className="delete-account-modal">
        <b style={{ color: "red" }}>Atenção:</b> Esta ação é irreversível!
        <br></br>
        <br></br>
        Digite o seguinte para prosseguir:{" "}
        <b style={{ color: "red" }}>deletar</b>
        <br></br>
        <br></br>
        <Input
          id="type-confirm"
          // label='Digite deletar para prosseguir'
          placeholder="digite deletar"
          value={confirmationText}
          onChange={(e) => setConfirmationText(e.target.value)}
        ></Input>
        <Button
          id="type-confirm-button"
          isError
          text="Deletar"
          disabled={confirmationText !== "deletar"}
          onClick={deleteUser}
        ></Button>
      </div>
    );
  };

  const createTokenConfirmModalContent = () => {
    if (token.length) {
      return (
        <div style={{ width: "600px", textAlign: "left" }}>
          <span style={{ fontSize: "14px", fontWeight: "600" }}>
            Token de integração
          </span>
          <div className="copy-token-section">
            <span>{token}</span>
            <div
              onClick={copyToken}
              title="Copiar"
              style={{ cursor: "pointer", display: "inline-flex" }}
            >
              <CopyIcon size={22} />
            </div>
          </div>
          <span style={{ fontSize: "12px", fontWeight: "500", color: "gray" }}>
            Certifique-se de salvar este token, você não poderá acessá-lo
            novamente.
          </span>
          <div className="copy-token-buttons">
            <Button
              text="Voltar"
              onClick={() => {
                setTokenConfirm(false);
                setToken("");
              }}
            ></Button>
          </div>
        </div>
      );
    }

    return (
      <div style={{ width: "600px", textAlign: "left" }}>
        {tokenLoading ? (
          <Loading show={true}></Loading>
        ) : (
          <>
            <div style={{ display: "block", marginTop: "25px" }}>
              <b style={{ color: "red" }}>Atenção:</b> A integração só será
              finalizada quando o token for cadastrado no{" "}
              <a
                href="https://nms.intelbras.com"
                target="_blank"
                rel="noreferrer"
              >
                NMS
              </a>{" "}
              (acesse{" "}
              <a
                href="https://guiasmanuais.intelbras.com.br/manual-inms/"
                target="_blank"
                rel="noreferrer"
              >
                manual do usuário
              </a>{" "}
              para mais detalhes). Após o token ser cadastrado no NMS, o
              gerenciamento de dispositivos pelo Remotize será <b>bloqueado</b>.
            </div>

            <br></br>
            <br></br>
            {!token?.length && (
              <>
                <div style={{ display: "flex" }}>
                  <Button
                    isError={true}
                    text="Cancelar"
                    onClick={() => setTokenConfirm(false)}
                  ></Button>
                  <Button
                    isSuccess
                    text="Confirmar"
                    onClick={handleCreateToken}
                  ></Button>
                </div>
              </>
            )}
          </>
        )}
      </div>
    );
  };

  if (!isp || !agreementDate) return <Loading show={true}></Loading>;

  return (
    <div id="my-account-page" className="page">
      <div className="remotize-version">{packageJson.version}</div>

      <Modal
        id="delete-my-account-modal"
        title="Deletar conta"
        show={deleteConfirm}
        content={deleteAccountModalContent()}
        type={ModalTypes.CONFIRM_WARNING}
        dismissText="Não, quero manter"
        confirmText="Sim, desejo deletar"
        onDismissClick={proceedToTypeConfirmation}
      ></Modal>

      <Modal
        id="delete-account-confirm-modal"
        title="Deletar conta"
        show={typeConfirm}
        content={typeConfirmModalContent()}
        type={ModalTypes.INFO}
        onOverlayClick={proceedToTypeConfirmation}
      ></Modal>

      <Modal
        id="create-token-confirm-modal"
        title="Criar token de integração NMS"
        show={tokenConfirm}
        content={createTokenConfirmModalContent()}
        type={ModalTypes.INFO}
        onOverlayClick={proceedToTypeConfirmation}
      ></Modal>

      <div style={{ display: "flex" }}>
        <div className="personal-info">
          <div id="personal-info-pic">
            <img alt="" src={menu.avatar.value}></img>
          </div>

          <div id="personal-info-data">
            <div className="user-info">
              <label>{user.name}</label>
              <span>{user.email}</span>
            </div>
            <div className="user-info">
              <label>Nível de acesso</label>
              <span>
                {user.type === RemotizeType.ADMIN ? "Administrador" : "Técnico"}
              </span>
            </div>
            <div className="user-info">
              <label>Informações do provedor</label>
              <span className="isp-info">
                {isp.name}
                <br></br>
                {isp.cnpj}
                <br></br>
                {isp.phone}
              </span>
            </div>
          </div>
        </div>

        <div className="personal-info">
          <div id="personal-info-data">
            <div className="user-info">
              <label>Privacidade e Termos de Uso</label>
              <span>
                <LGPDFileLink
                  label="Termos de Uso"
                  linkID="terms_of_use"
                ></LGPDFileLink>
                <LGPDFileLink
                  label="Política de Privacidade"
                  linkID="privacy_policy"
                ></LGPDFileLink>
              </span>
              <br></br>
              Estes são os documentos lidos e aceitos por você em{" "}
              {agreementDate.toLocaleDateString("pt-br")} às{" "}
              {agreementDate.toLocaleTimeString("pt-br")}.
            </div>
            <div className="user-info">
              <label>Remover conta</label>
              <Button
                isError
                text="Deletar minha conta"
                onClick={() => setDeleteConfirm(true)}
              ></Button>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="integration-card">
        <label>Integração com NMS</label>
        <span style={{ padding: "20px 0 5px 0", display: "block" }}>
          Integração com NMS não realizada.
        </span>
        <Button
          isSuccess
          text="Criar token de integração"
          onClick={() => setTokenConfirm(true)}
        ></Button>
      </div> */}
    </div>
  );
}
